import { createFileRoute } from "@tanstack/react-router";
import { RemoteAppPage } from "@/components/apps/RemoteAppPage";
import { remoteAppSeo } from "@/lib/page-seo";
import heroScreenshot from "@/assets/remote-app/screenshots/en/inext-remote-app-control-screen.png";

export const Route = createFileRoute("/solutions/inext-remote")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    remoteAppSeo(loaderData?.href ?? "/solutions/inext-remote", heroScreenshot),
  component: RemoteAppPage,
});
